import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import "./styles.css";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { BrandProvider } from "./brand/BrandProvider";

const qc = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 10_000 } } });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <BrandProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrandProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
